module.exports = __webpack_public_path__ + "static/img/status-grey.42f1e72.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/status-grey.svg
// module id = 1453
// module chunks = 0